import type { HouseholdState, InventoryItem } from '../types';

export interface WasteRisk {
  item: InventoryItem;
  level: 'critical' | 'soon' | 'stable';
  message: string;
}

export function getWasteRisks(state: HouseholdState): WasteRisk[] {
  return [...state.inventory]
    .sort((a, b) => a.expiresInDays - b.expiresInDays)
    .slice(0, 6)
    .map((item) => ({
      item,
      level: item.expiresInDays <= 1 ? 'critical' : item.expiresInDays <= 3 ? 'soon' : 'stable',
      message: item.expiresInDays <= 0 ? 'Use today' : item.expiresInDays === 1 ? 'Use today' : `Use within ${item.expiresInDays} days`,
    }));
}

export function weeklyCoverage(state: HouseholdState) {
  const dinnerCount = state.meals.filter((m) => m.mealType === 'dinner').length;
  const shoppingItems = state.trips.reduce((sum, trip) => sum + trip.items.length, 0);
  const estimatedSpend = state.trips.reduce((sum, trip) => sum + trip.estimatedCost, 0);
  const useSoon = state.inventory.filter((i) => i.expiresInDays <= 3).length;
  return { dinnerCount, shoppingItems, estimatedSpend, useSoon };
}

export function humanizeQuantity(quantity: number, unit: string) {
  return Number.isInteger(quantity) ? `${quantity} ${unit}` : `${quantity.toFixed(1)} ${unit}`;
}
